module.exports = __webpack_public_path__ + "img/FullWidthImageSlider.6de0f5f3.png";